import { useLocation, useNavigate } from "react-router-dom";
import { useLocale } from "@/i18n";

const FLAGS = [
  { locale: "pt", lang: "br", img: "https://flagcdn.com/w40/br.png", alt: "Português (Brasil)", testid: "locale-br-btn" },
  { locale: "es", lang: "py", img: "https://flagcdn.com/w40/py.png", alt: "Español (Paraguay)", testid: "locale-py-btn" },
];

export default function FlagToggle() {
  const { locale, setLocale } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();

  const pick = (f) => {
    setLocale(f.locale);
    const path = location.pathname;
    const bare = path.replace(/^\/(br|py)/, "") || "/";
    if (bare === "/" || bare === "/cadastro" || bare === "/entrar") {
      navigate(`/${f.lang}${bare === "/" ? "" : bare}`);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="locale-toggle">
      {FLAGS.map((f) => (
        <button
          key={f.locale}
          data-testid={f.testid}
          onClick={() => pick(f)}
          title={f.alt}
          aria-label={f.alt}
          className={`rounded-md p-0.5 transition-all duration-200 ${
            locale === f.locale
              ? "ring-2 ring-amber-500 opacity-100"
              : "opacity-50 hover:opacity-90"
          }`}
        >
          <img src={f.img} alt={f.alt} className="w-7 h-5 rounded-sm object-cover" />
        </button>
      ))}
    </div>
  );
}
